import React, { useState, MouseEvent, ChangeEventHandler } from 'react'
import ViewProps from '../../types/ViewProps'
import Answer from '../../types/Answer'
import Typed, { Segment } from '../Typed'

export default ({ data, path, handleClick, appState, setAppState }: ViewProps) => {
    const q = data!.find(q => q.id === path)
    
    if (appState.next === '') {
        setAppState({ ...appState, next: 'start' })
    }

    return (
        <div>
            <h1 className="title">
                <Typed>What does <Segment delay={500} duration={300}>it take </Segment>to go to ECU?</Typed>
            </h1>
            <h2 className="subtitle landing">Let’s build a personalized list of what you need to know.</h2>
            <div onClick={handleClick} className='nav-link nav-link--landing'>Next</div>
        </div>
    )
}